import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { linkedInRegExp, patternEmail, patternNumbersOnly } from '@core/models/pattern';
import { CandidatService } from '@core/services/candidat-service/candidat.service';
import { LocalStorageService } from '@core/services/local-storage.service';
import { ProjetService } from '@core/services/projet-service/projet.service';
import { SharedService } from '@shared/shared.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-detail-employee',
  templateUrl: './detail-employee.component.html',
  styleUrls: ['./detail-employee.component.css']
})
export class DetailEmployeeComponent {
  employeeform: FormGroup = this.createEmployeeForm();

  /* boolean */
  disabled: boolean = false;
  /* string */
  idConsultant: string = '';
  idEmp: number = 0;
  idclientConnected: any;
  /*array */
  listprojet: { id: number; name: string }[] = [];
  /*subscriptions*/
  private unsubscribeAll: Subject<void> = new Subject();

  constructor(private formBuilder: FormBuilder, private localStorageService: LocalStorageService,
    private router: Router, 
    private projetservice: ProjetService, 
    private spinner: NgxSpinnerService,
    private dataService: SharedService,


  ) {
 
    this.getListprojet()

   // this.getIdEmployee()
  }
  ngOnInit(){
    setTimeout(() => {
      this.dataService.getData((data) => {
      if(data.id){
          this.getEmployeeDetails(data)
      }
    });}, 2000);   
  }
  getListprojet() {
    this.idclientConnected =
      this.localStorageService.getData('clientConnected');

    this.projetservice.getprojets(this.idclientConnected).subscribe({
      next: (response) => {
        console.log('response projet', response);

        this.listprojet = response.data;
      },
      error: (error) => {
        console.error('Error fetching projet: ', error);
      },
    });
  }
  /* create add candidat form */
  createEmployeeForm(data?: any) {
 
    return this.formBuilder.group(
      {
        first_name: [data ? data?.first_name : '', [Validators.required]],
        last_name: [data ? data?.last_name : '', [Validators.required]],
        emailProClient: [
          data ? data?.emailProClient : '',
          [Validators.pattern(patternEmail)],
        ],
        email: [
          data ? data?.email : '',
          [
            Validators.required,
            Validators.email,
            Validators.pattern(patternEmail),
          ],
        ],
        linkedin_link: [data ? data?.linkedin_link : '', [Validators.pattern(linkedInRegExp)]],
        project_ids: [data ? data?.project_ids : []],
        poste: [data ? data?.poste : ''],
        cv: [data && data.cv ? data.cv : ''],
        date_first_contract: [data ? data?.date_first_contract : ''],
        salary: [
          data ? data?.salary : '',
          [Validators.pattern(patternNumbersOnly)],
        ],
        consultant_client_final_id: [
          data ? data?.consultant_client_final_id : '',
        ],
        user_id: [data ? data?.user_id : ''],
        clientFinal_id: [data ? data?.clientFinal_id : ''],
      },
      {}
    );
  
  }
 
  navigateToProfile() {
    console.log('Navigate to profile', this.idEmp);
    this.router.navigate(['/candidats/profilecandidatesn/'+ this.idEmp  ]);
    
  }
  getEmployeeDetails(data:any) {
    this.getListprojet()
    this.employeeform.patchValue(data)
    this.spinner.show()
   this.createEmployeeForm(data)
   if(this.listprojet.length>0){
    const projectNames = data.project_names || [];
    const selectedProjectIDs = this.listprojet.filter((project) => projectNames.includes(project.name)).map((project) => project.id);
    this.employeeform.get('project_ids')?.setValue(selectedProjectIDs);
  }
    this.employeeform.get('user_id')?.setValue(data?.id);
    this.employeeform
      .get('consultnat_client_final_id')
      ?.setValue(data.consultant_client_final_id);
    this.employeeform
      .get('date_first_contract')
      ?.setValue(data.salary_date_first_contract);
      this.idEmp = data.id
    this.employeeform.disable()

    this.spinner.hide()

  }
  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }

}
